<template>
  <v-layout wrap justify-center align-center>
    <v-flex xs12 sm8 md4>
      <v-card elevation="12">
        <!-- <v-img src="https://syclus.com.br/img/LogoHome.png"></v-img> -->
        <v-toolbar id="login-toolbar" flat color="transparent">
          <v-toolbar-title class="d-flex align-center font-weight-bold">
            <img src="@/assets/logo.png" class="mr-3" alt="Syclus">
            Syclus CRM
          </v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <v-form
            ref="form"
            lazy-validation
            v-model="valid"
          >
            <v-text-field
              v-model="usuario"
              :rules="usuarioRules"
              prepend-inner-icon="person"
              label="Usuário"
              @keyup.enter="login"
              autofocus
              outline
            ></v-text-field>
            <v-text-field
              v-model="senha"
              :rules="senhaRules"
              prepend-inner-icon="lock"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              label="Senha"
              outline
              @keyup.enter="login"
            ></v-text-field>
            <v-btn 
              :disabled="!valid" 
              block 
              color="primary" 
              @click="login"
              :loading="loading"
            >Entrar</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'LoginForm',
  props: ['loading'],
  data: () => ({
    valid: true,
    usuario: '',
    senha: '',
    showPassword: false,
    usuarioRules: [
      v => !!v || 'Informe o usuário'
    ],
    senhaRules: [
      v => !!v || 'Informe a senha',
      v => (v && v.length >= 6) || 'Senha precisa ter no mínimo 6 caracteres'
    ]
  }),
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.$emit('login', { usuario: this.usuario, senha: this.senha });
      }
    }
  }

}
</script>

<style>
#login-toolbar > .v-toolbar__content {
  padding: 0 16px !important;
}
</style>